import React from 'react';
import Classes from './Hero.module.css';
import Navbar from '../../Components/Navbar/Navbar';
import { motion } from 'framer-motion';
import { fadeUpVariant } from '../../../../../utils/motionVariants';
import { HERO_SRC, HERO_SRCSET, HERO_SIZES } from '../../../../../utils/heroImage';
import { useGoogleRating, formatRating } from '../../../../../utils/googleRating';
import { scrollToElement } from '../../../../../utils/scrollToElement';

export default function Hero() {
    const googleRating = useGoogleRating();

    return (
        <>
            <Navbar />
            <div className={Classes.hero} id='demo'>
                {/* Background photo */}
<div className={Classes.heroSwiper}>
                    <img
                        src={HERO_SRC}
                        srcSet={HERO_SRCSET}
                        sizes={HERO_SIZES}
                        alt=""
                        className={Classes.bgImage}
                        draggable={false}
                        fetchpriority="high"
                        decoding="async"
                    />
                </div>


                {/* Hero Content */}
                <motion.div {...fadeUpVariant(0.1, 60)} className={Classes.heroContent}>

                    <motion.div {...fadeUpVariant(0.15)} >
                        <a
                            href='#testimonials'
                            aria-label='Read our reviews'
                            onClick={(e) => {
                                e.preventDefault();
                                // Land just below the fixed navbar so the reviews heading is visible
                                const navHeight = document.querySelector('header')?.offsetHeight || 70;
                                scrollToElement('testimonials', -navHeight);
                            }}
                        >
                            <div className={Classes.ratingPill} >
                                <span className={Classes.ratingStars} aria-label='5 out of 5 stars'>
                                    {[0, 1, 2, 3, 4].map((i) => (
                                        <svg key={i} viewBox='0 0 20 20' aria-hidden='true'>
                                            <path d='M10 1.5l2.6 5.3 5.9.9-4.25 4.1 1 5.8L10 14.9l-5.25 2.7 1-5.8L1.5 7.7l5.9-.9z' />
                                        </svg>
                                    ))}
                                </span>
                                <span className={Classes.ratingScore}>{formatRating(googleRating.rating)}</span>
                                <span className={Classes.ratingDivider} aria-hidden='true' />
                                <span className={Classes.ratingText}>Top Rated in South Florida</span>
                            </div>
                        </a>
                    </motion.div>

                    <motion.h1 {...fadeUpVariant(0.2)}>
                        5-Star Dryer Vent & Appliance<br />Services in{' '}
                        <span className={Classes.highlight}>South Florida</span>
                    </motion.h1>

                    <motion.h5 {...fadeUpVariant(0.3)}>
                        Keeping your home safe, efficient, and running smoothly with expert <br /> service you can trust.
                    </motion.h5>

                    <motion.div {...fadeUpVariant(0.4)} className={Classes.buttons} >
                        <a href='https://book.housecallpro.com/book/Quick-Appliance-Services-and-Dryer-Vent-Cleaning/1d772c9908b14627bf68d004ecf2882d' target='_blank' rel='noreferrer' >
                            <button className={Classes.button1} >
                                <h5>Book an appointment online</h5>
                            </button>
                        </a>
                        {/* <button onClick={() => { navigateTo('/contact-us') }} className={Classes.button2} >
                        <h5>Contact Us</h5>
                    </button> */}
                    </motion.div>
                </motion.div>
            </div>
        </>
    );
}
